import React, { useState } from "react";
import SEO from "../../../components/SEO";
import { Plus, Minus } from "lucide-react";
import img46 from "../../../assets/img46.webp";

const FAQ_CATEGORIES = [
  { id: "life", label: "Assurance-vie" },
  { id: "superVisa", label: "Assurance Super Visa" },
  { id: "disability", label: "Assurance invalidité" },
  { id: "critical", label: "Assurance maladies graves" },
  { id: "investments", label: "Investissements" },
];

const FAQ_DATA = {
  life: {
    heading: null,
    faqs: [
      {
        question: "Quand vais-je recevoir un paiement d'un contrat d'assurance-vie ?",
        answer:
          "Un contrat couvre le paiement du montant assuré jusqu'à sa date d'échéance, pour des dates spécifiées à intervalles périodiques, ou en cas de décès malheureux, s'il survient plus tôt.",
      },
      {
        question: "Contre quels risques l'assurance-vie protège-t-elle ?",
        answer:
          "Il existe deux principaux risques de la vie contre lesquels des polices d'assurance-vie spécifiques protègent, à savoir les risques de décès prématuré laissant une famille dépendante à se prendre en charge, ainsi que les risques de vieillesse sans sécurité financière.",
      },
      {
        question: "Quels types d'assurance-vie sont disponibles ?",
        answer:
          "Il existe deux principaux types d'assurance-vie : l'assurance-vie temporaire pour les besoins à court terme et l'assurance-vie permanente pour les besoins à long terme.",
      },
      {
        question:
          "Quels sont les avantages de souscrire une police d'assurance-vie ?",
        answer:
          "L'assurance-vie présente de nombreux avantages, notamment la sécurité pour l'avenir de vos enfants, votre sécurité financière après la retraite et la sécurité de votre famille en cas de décès prématuré. Vous pouvez également restructurer votre régime fiscal pour bénéficier à votre famille et rembourser votre prêt hypothécaire facilement.",
      },
      {
        question:
          "L'assurance-vie offre-t-elle des avantages pour les personnes célibataires ?",
        answer:
          "Pour les personnes célibataires, l'assurance-vie est nécessaire pour couvrir tout type d'obligations financières telles que des prêts ou des paiements par carte de crédit impayés, afin que leurs parents restent libres de toute charge financière en cas d'incident malheureux.",
      },
      {
        question: "Ai-je vraiment besoin d'une assurance-vie si je suis jeune et en bonne santé ?",
        answer:
          "Souscrire une assurance quand vous êtes jeune et en bonne santé signifie généralement des primes plus basses et une approbation plus facile, et cela garantit une protection avant que votre santé ou vos responsabilités ne changent.",
      },
      {
        question: "Pourquoi devrais-je souscrire une assurance-vie si je n'ai pas d'enfants ?",
        answer:
          "Souscrire une assurance-vie assurera un mode de vie confortable à votre conjoint même si vous n'avez pas d'enfants et lui offrira un avenir financier stable en votre absence. Étant donné que votre conjoint devra toujours payer les mensualités du prêt, l'assurance-vie l'aidera à faire face et à aller de l'avant.",
      },
      {
        question: "Dois-je revoir ma police d'assurance tous les quelques années ?",
        answer:
          "Oui. Il est judicieux de revoir la couverture après des événements majeurs de la vie, comme un mariage, un nouvel emploi, l'achat d'une maison ou l'arrivée d'enfants, ou au moins tous les quelques années pour l'aligner sur vos besoins.",
      },
      {
        question: "Puis-je reporter l'achat de cette police pour quelques années ?",
        answer:
          "L'assurance-vie est un outil financier précieux dont vous avez besoin jusqu'à ce que vous accumuliez suffisamment d'actifs liquides et/ou diminuiez votre dépendance. Vous ne pouvez pas spéculer sur le moment de votre décès. Vos proches pourraient ne pas avoir d'autres sources de revenu si vous décédez prématurément sans couverture d'assurance ou après épuisement de vos actifs actuels. Par conséquent, vous ne devriez jamais retarder cette décision et devriez considérer la souscription d'une assurance comme une priorité.",
      },
      {
        question: "Comment vais-je faire face aux coûts de l'assurance-vie ?",
        answer:
          "Comparée à la précieuse sécurité financière qu'offre l'assurance-vie, le prix a relativement peu d'importance, car il dépend du montant de couverture dont vous avez besoin, du montant que vous pouvez économiser et de la compagnie d'assurance que vous choisissez. De nos jours, des outils en ligne sont disponibles à portée de main pour comparer, économiser et acheter des plans qui vous offrent un retour sur investissement garanti.",
      },
      {
        question:
          "Quelle est la différence entre le souscripteur (client), l'assuré et le bénéficiaire ?",
        answer:
          "Le souscripteur possède la police et paie les primes, l'assuré est la personne dont la vie est couverte, et le bénéficiaire est la personne ou l'organisation qui reçoit le versement en cas de décès de l'assuré.",
      },
      {
        question:
          "Devez-vous informer l'assureur si votre état de santé change pendant que le contrat d'assurance est en vigueur ?",
        answer:
          "Pour l'assurance-vie, la réponse est « non ». L'assureur évalue votre santé uniquement au moment de l'émission du contrat.",
      },
      {
        question: "En cas de décès, quand l'assurance est-elle versée ?",
        answer:
          "Une fois que l'assureur a reçu les formulaires de réclamation et la preuve de décès et terminé toute révision requise, la prestation de décès est généralement versée en une somme forfaitaire aux bénéficiaires.",
      },
      {
        question:
          "L'assurance est-elle versée si l'assuré est victime d'un homicide ?",
        answer:
          "Si la personne condamnée pour l'homicide est le bénéficiaire, elle perdra le droit à la prestation. S'il y a d'autres bénéficiaires qui n'avaient rien à voir avec le décès de l'assuré, ils auront droit au montant de l'assurance.",
      },
      {
        question: "L'assurance est-elle versée si l'assuré se suicide ?",
        answer:
          "De nombreuses polices incluent une exclusion pour suicide pendant les première ou deuxième années. Si le décès survient pendant cette période, les primes peuvent être remboursées plutôt que la prestation complète ; après la période d'exclusion, les prestations normales peuvent s'appliquer. Si vous ou quelqu'un que vous connaissez est en difficulté, il est important de contacter un adulte de confiance ou un professionnel pour obtenir de l'aide.",
      },
      {
        question: "Si l'assuré disparaît, l'assurance est-elle versée ?",
        answer:
          "Les assureurs exigent généralement une preuve légale de décès, comme un certificat de décès ou une déclaration judiciaire, avant de payer une réclamation lorsque quelqu'un disparaît pendant une longue période.",
      },
      {
        question:
          "Quelle est la différence entre un bénéficiaire révocable et un bénéficiaire irrévocable ?",
        answer:
          "Un bénéficiaire révocable peut être modifié par le souscripteur à tout moment, tandis qu'un bénéficiaire irrévocable doit généralement donner son consentement écrit avant de pouvoir être retiré ou que sa part soit modifiée.",
      },
      {
        question: "Qu'est-ce qu'un avenant dans une police d'assurance-vie ?",
        answer:
          "Un avenant est un ajout à une police standard qui offre des avantages supplémentaires ou modifie les conditions de la police. Les avenants courants comprennent une assurance supplémentaire incluant une assurance temporaire ou maladies graves, l'hospitalisation, la renonciation ou le remboursement de primes, un revenu complémentaire et une prestation de décès accidentel. Pour toute demande spécifique concernant les avenants, veuillez prendre rendez-vous avec nous.",
      },
      {
        question: "Comment puis-je réduire le coût de l'assurance-vie ?",
        answer:
          "Souscrire une assurance-vie quand vous êtes plus jeune et en meilleure santé, opter pour une assurance-vie temporaire plutôt que des polices permanentes, adopter un mode de vie sain et comparer avec précision différentes polices et fournisseurs peuvent aider à réduire les coûts.",
      },
      {
        question: "Que se passe-t-il si je manque un paiement de prime ?",
        answer:
          "Les polices comportent généralement une période de grâce, vous accordant un certain temps pour payer la prime sans perdre la couverture. Si le paiement n'est pas effectué dans le délai de grâce, la police peut périmer et vous pourriez perdre la couverture.",
      },
      {
        question: "Puis-je modifier ma police d'assurance-vie ?",
        answer:
          "Oui, dans de nombreux cas, vous pouvez ajuster votre police d'assurance-vie. Les polices temporaires peuvent offrir des options de conversion en police permanente, tandis que les polices permanentes peuvent permettre des modifications à votre prestation de décès et à vos paiements de primes. Assurez-vous de consulter votre assureur pour les détails.",
      },
      {
        question: "Comment choisir un bénéficiaire ?",
        answer:
          "Un bénéficiaire est quelqu'un que vous désignez pour recevoir la prestation de décès de votre police. Vous pouvez choisir n'importe qui, comme un membre de la famille, un ami, une fiducie ou un organisme de bienfaisance. Il est important de tenir compte de qui serait le plus touché financièrement par votre décès et de mettre à jour votre désignation de bénéficiaire à mesure que votre situation de vie change.",
      },
      {
        question: "Puis-je avoir plusieurs polices d'assurance-vie ?",
        answer:
          "Oui, vous pouvez avoir plus d'une police d'assurance-vie. Avoir plusieurs polices peut vous aider à répondre à différents besoins et objectifs financiers, ou simplement à ajouter une couverture supplémentaire à mesure que votre situation évolue.",
      },
      {
        question: "Les primes d'assurance-vie sont-elles déductibles d'impôt ?",
        answer:
          "Dans la plupart des cas, les primes d'assurance-vie ne sont pas déductibles d'impôt. Cependant, la prestation de décès versée aux bénéficiaires est généralement exempte d'impôt sur le revenu.",
      },
      {
        question:
          "Quelles informations dois-je fournir pour demander une assurance-vie ?",
        answer:
          "Vous devrez probablement fournir des informations personnelles, des antécédents médicaux et peut-être passer un examen médical.",
      },
      {
        question: "Puis-je obtenir une assurance-vie en ligne ?",
        answer:
          "Oui, de nombreuses compagnies offrent la possibilité de demander et même d'obtenir une approbation pour l'assurance-vie en ligne.",
      },
      {
        question:
          "Quelle est la différence entre un agent d'assurance-vie et un courtier ?",
        answer:
          "Un agent travaille pour une compagnie d'assurance spécifique et vend ses produits, tandis qu'un courtier représente le client et peut vendre des polices de plusieurs compagnies.",
      },
      {
        question: "Une police d'assurance-vie peut-elle être contestée ?",
        answer:
          "Oui, les polices peuvent être contestées pour des raisons telles que la fraude ou la fausse déclaration dans un certain délai après l'émission.",
      },
      {
        question: "Qu'est-ce que l'assurance-vie entière ?",
        answer:
          "L'assurance-vie entière offre une couverture à vie, comprend une prestation de décès et accumule une valeur de rachat au fil du temps.",
      },
      {
        question: "Puis-je emprunter sur ma police d'assurance-vie ?",
        answer:
          "Oui, si vous avez une police d'assurance-vie à valeur de rachat, vous pouvez emprunter sur la valeur de rachat.",
      },
      {
        question: "De quel montant d'assurance-vie ai-je besoin ?",
        answer:
          "Cela varie selon les circonstances individuelles, notamment le revenu, les dettes, le style de vie et les personnes à charge. Une règle générale courante est 10 à 15 fois votre revenu annuel, mais les besoins spécifiques peuvent varier.",
      },
      {
        question: "Qu'est-ce que l'assurance-vie ?",
        answer:
          "L'assurance-vie est un contrat par lequel un assureur verse une prestation de décès aux bénéficiaires au décès du souscripteur. Cela aide les proches à couvrir les dépenses ou à remplacer le revenu perdu après le décès du souscripteur.",
      },
      {
        question: "Qui devrait envisager de souscrire une assurance-vie ?",
        answer:
          "L'assurance-vie est idéale pour toute personne ayant des personnes à charge ou des obligations financières, comme des prêts hypothécaires ou des dettes, qui souhaite s'assurer que ses proches seront financièrement en sécurité après son décès.",
      },
      {
        question: "Comment fonctionne la valeur de rachat dans une police permanente ?",
        answer:
          "La valeur de rachat est une caractéristique similaire à une épargne qui croît dans une police permanente. Elle peut être empruntée, retirée ou laissée à s'accumuler pour une utilisation ultérieure.",
      },
      {
        question: "Qu'est-ce que l'assurance-vie universelle et en quoi est-elle différente ?",
        answer:
          "L'assurance-vie universelle est un type d'assurance permanente offrant des primes flexibles et des prestations de décès ajustables. Elle comprend une valeur de rachat qui peut croître selon les taux d'intérêt.",
      },
      {
        question: "Qu'est-ce que la prestation de décès ?",
        answer:
          "La prestation de décès est la somme d'argent versée aux bénéficiaires au décès de l'assuré. Ce montant est généralement libre d'impôt et peut être utilisé pour tout besoin financier.",
      },
      {
        question: "Comment fonctionne la souscription accélérée ?",
        answer:
          "La souscription accélérée utilise des données provenant des dossiers médicaux et des cotes de crédit pour accélérer l'approbation, éliminant souvent le besoin d'un examen médical.",
      },
      {
        question: "Puis-je changer mon bénéficiaire ultérieurement ?",
        answer:
          "Oui, vous pouvez changer votre bénéficiaire à tout moment, sauf si la police indique qu'il est irrévocable. Cela vous donne le contrôle sur qui reçoit le versement.",
      },
      {
        question: "Les versements d'assurance-vie sont-ils imposables ?",
        answer:
          "Les prestations de décès sont généralement exemptes d'impôt. Cependant, si la prestation fait partie d'une succession imposable, des impôts successoraux peuvent s'appliquer.",
      },
      {
        question: "Qu'est-ce que la conversion de terme ?",
        answer:
          "La conversion de terme vous permet de convertir une police temporaire en police permanente sans nouvelle souscription. C'est utile avec l'âge ou si votre santé se détériore.",
      },
      {
        question: "Qu'est-ce que la valeur de rachat ?",
        answer:
          "La valeur de rachat est le montant que vous recevriez si vous annulez une police permanente. C'est la valeur de rachat moins les frais de rachat, qui varient selon la police et la compagnie.",
      },
      {
        question: "Qu'est-ce qu'une police d'assurance-vie sans examen médical ?",
        answer:
          "Les polices sans examen médical ne nécessitent pas d'examen médical et utilisent l'analyse de données pour l'approbation. Elles sont pratiques mais peuvent avoir des primes plus élevées en raison de données de santé limitées.",
      },
      {
        question:
          "Quelle est la différence entre l'assurance-vie fixe et variable ?",
        answer:
          "Les polices fixes offrent une croissance stable de la valeur de rachat, tandis que les polices variables vous permettent d'investir des liquidités dans des sous-comptes, ce qui peut entraîner des gains ou des pertes plus élevés.",
      },
      {
        question: "Puis-je retirer de l'argent de ma police d'assurance-vie ?",
        answer:
          "Oui, de nombreuses polices permanentes permettent des retraits de la valeur de rachat, bien que cela puisse réduire la prestation de décès ou entraîner des frais, selon la police.",
      },
      {
        question: "Que sont les avantages du vivant ?",
        answer:
          "Les avantages du vivant permettent aux souscripteurs d'accéder à une partie de la prestation de décès s'ils sont diagnostiqués avec une maladie terminale, chronique ou grave, offrant un soulagement financier pendant la maladie.",
      },
      {
        question: "Qu'est-ce qu'un prêt sur police et comment fonctionne-t-il ?",
        answer:
          "Un prêt sur police vous permet d'emprunter sur la valeur de rachat d'une police permanente, généralement avec un faible intérêt. Les prêts non remboursés réduisent la prestation de décès s'ils ne sont pas remboursés.",
      },
      {
        question:
          "Quelle est la différence entre l'assurance-vie collective et individuelle ?",
        answer:
          "L'assurance-vie collective est fournie par un employeur et peut être limitée en couverture, tandis que les polices individuelles sont achetées personnellement et personnalisées selon vos besoins spécifiques.",
      },
      {
        question: "Qu'implique la souscription ?",
        answer:
          "La souscription évalue des facteurs de risque tels que l'âge, la santé, le style de vie et la profession pour déterminer l'admissibilité, les taux de primes et les limites de couverture.",
      },
      {
        question: "Qu'est-ce que la période de contestation ?",
        answer:
          "La période de contestation, généralement les deux premières années d'une police, est le moment où l'assureur peut enquêter et refuser une réclamation s'il constate de graves inexactitudes dans la demande.",
      },
      {
        question: "Qu'est-ce que la clause d'incontestabilité ?",
        answer:
          "C'est généralement une période de deux ans pendant laquelle les assureurs peuvent examiner et refuser des réclamations pour inexactitudes. Après cette période, ils ne peuvent généralement plus contester une réclamation.",
      },
      {
        question: "Qu'est-ce que la couverture décès accidentel et mutilation (DAM) ?",
        answer:
          "La DAM est un avenant qui verse une prestation supplémentaire si l'assuré décède ou subit une blessure grave due à un accident, offrant une protection financière supplémentaire.",
      },
      {
        question: "Qu'est-ce que la période d'examen libre ?",
        answer:
          "La période d'examen libre (10 à 30 jours) permet aux souscripteurs d'examiner la police après l'achat et de l'annuler pour un remboursement complet s'ils ne sont pas satisfaits.",
      },
      {
        question: "Comment les primes d'assurance-vie sont-elles déterminées ?",
        answer:
          "Les primes sont basées sur des facteurs tels que l'âge, la santé, la profession, le style de vie, le type de police et le montant de couverture. Les profils plus risqués peuvent entraîner des primes plus élevées.",
      },
      {
        question: "L'assurance-vie peut-elle couvrir les frais d'inhumation ou funéraires ?",
        answer:
          "Oui, les prestations d'assurance-vie peuvent être utilisées à toutes fins, y compris les frais funéraires, aidant les familles à gérer ces dépenses sans charge financière supplémentaire.",
      },
    ],
  },

  superVisa: {
    heading: null,
    faqs: [
      {
        question:
          "L'assurance Super Visa est-elle une exigence obligatoire du Super Visa ?",
        answer: "Oui.",
      },
      {
        question: "Qui peut souscrire une assurance Super Visa ?",
        answer:
          "L'assurance Super Visa peut être souscrite par des citoyens canadiens ou des résidents permanents pour offrir une protection aux parents ou grands-parents qui leur rendent visite avec un Super Visa.",
      },
      {
        question:
          "Quels facteurs dois-je prendre en compte avant de faire une demande de Super Visa ?",
        answer:
          "Vous devriez examiner les exigences de revenu, la lettre d'invitation, les besoins en examen médical et vous assurer que votre police d'assurance répond aux règles gouvernementales en matière de montant de couverture, de date de début et d'options de remboursement.",
      },
      {
        question: "Quelle est la limite d'âge pour faire une demande de Super Visa ?",
        answer:
          "Il n'y a aucune restriction d'âge pour faire une demande de Super Visa. Vous devez être un parent ou grand-parent d'un citoyen canadien ou d'un résident permanent.",
      },
      {
        question:
          "Quelles sont les exigences pour être couvert par une police d'assurance médicale de 100 000 $ pour 1 an ?",
        answer:
          "Selon le gouvernement du Canada, vous êtes admissible à souscrire cette assurance si vous êtes un visiteur au Canada qui n'est pas couvert par un régime gouvernemental provincial ou territorial.",
      },
      {
        question: "Quelles sont les options de paiement pour une assurance Super Visa ?",
        answer:
          "La police peut être souscrite par carte de crédit, en espèces ou par chèque.",
      },
      {
        question: "Puis-je souscrire une assurance Super Visa pour 2 ans ?",
        answer:
          "La plupart des compagnies ne vous permettent pas d'acheter une assurance pour plus d'un an. Cependant, dans certains cas, certaines compagnies peuvent offrir des plans de 18 mois ou 2 ans.",
      },
      {
        question:
          "Quelle est la différence entre l'assurance pour visiteurs et l'assurance Super Visa ?",
        answer:
          "L'assurance visiteurs est généralement à court terme et flexible. L'assurance Super Visa doit respecter des règles plus strictes : couverture minimale plus élevée, durée plus longue et preuve de paiement pour soutenir la demande de visa.",
      },
      {
        question:
          "Si je voyage pendant un ou deux mois, ai-je quand même besoin d'une assurance Super Visa ?",
        answer:
          "Si vous êtes titulaire ou demandeur d'un Super Visa, il est obligatoire de souscrire une assurance pour une durée minimale de 365 jours avec une couverture de 100 000 $ ou plus. Par la suite, vous pouvez obtenir un remboursement partiel avec la preuve que vous êtes rentré tôt sans réclamation déposée, si vous avez séjourné moins d'un an.",
      },
      {
        question:
          "Si le visa est refusé, obtiendrai-je un remboursement complet du montant de la prime ?",
        answer:
          "Oui, les compagnies d'assurance remboursent le montant total de la prime sur réception du document de refus de visa.",
      },
      {
        question:
          "Je ne sais pas quand mes parents arriveront au Canada. Puis-je modifier la date d'effet de la police à tout moment ?",
        answer:
          "Oui, le plan est très flexible. Les dates d'effet de la police peuvent être modifiées, à condition que le souscripteur ou l'acheteur fournisse à la compagnie d'assurance la nouvelle date d'effet avant la date de début originale.",
      },
      {
        question:
          "Si j'oublie de changer la date d'effet de la police, que se passerait-il ?",
        answer:
          "Si le visa n'est pas accordé ou si le demandeur n'arrive pas à la date mentionnée sur la date d'effet de la police, la police peut être modifiée avec une nouvelle date d'effet sur présentation d'un document de voyage valide. Des frais peuvent s'appliquer si le changement de date est demandé après le début de la police.",
      },
      {
        question:
          "La police d'assurance couvre-t-elle les situations médicales non urgentes ou les examens de santé de routine ?",
        answer:
          "Ce type de police d'assurance ne couvre que les situations médicales aiguës et inattendues. Les examens de routine ne sont pas couverts par ce plan.",
      },
      {
        question: "Qu'est-ce qu'une condition préexistante ?",
        answer:
          "C'est une condition médicale, maladie ou blessure connue du client avant le voyage. Pour cette condition, le client a pu avoir reçu une consultation médicale, un diagnostic et/ou un traitement médical par un médecin.",
      },
      {
        question:
          "Si j'ai une condition médicale grave, puis-je quand même obtenir la police d'assurance ?",
        answer:
          "Oui, une couverture pour les conditions médicales préexistantes peut être offerte. Veuillez contacter l'un de nos conseillers pour discuter de votre cas.",
      },
      {
        question:
          "Suis-je encore couvert si j'ai une condition médicale préexistante ?",
        answer:
          "Certains plans offrent une couverture pour les conditions préexistantes stables si elles n'ont pas évolué pendant une période déterminée (par exemple 90 ou 180 jours). D'autres les excluent complètement. Vous devez vérifier attentivement les règles de stabilité.",
      },
      {
        question: "Pourquoi dois-je remplir le questionnaire médical ?",
        answer:
          "Il peut y avoir des questions médicales dans votre demande en ligne. Cela nous permettra d'obtenir un tableau médical complet de votre état de santé afin que nous puissions vous fournir la meilleure police d'assurance pour votre situation. Vous devez répondre à toutes les questions honnêtement, sinon votre couverture peut être annulée. En cas de soumission d'une réclamation, la compagnie d'assurance enquêtera pour déterminer si votre condition était préexistante et/ou si vous avez été honnête dans votre demande.",
      },
      {
        question:
          "Mon assurance Super Visa peut-elle offrir une couverture dans des pays autres que le Canada ?",
        answer:
          "Oui, à condition que le voyage commence et se termine au Canada et que la majorité du temps y soit passée, le même plan peut vous couvrir dans d'autres pays, à l'exception de votre pays d'origine. Cependant, l'assurance Super Visa ne couvre pas si vous voyagez dans un pays pour lequel le ministère des Affaires étrangères du Canada a émis un avertissement de ne pas voyager. Veuillez vous référer à votre police d'assurance ou consulter l'un de nos conseillers pour en savoir plus.",
      },
      {
        question:
          "Que se passerait-il si le souscripteur retourne dans son pays d'origine après moins d'un an ?",
        answer:
          "Le payeur (qui a souscrit la police) obtiendra un remboursement partiel au prorata quotidien, à condition qu'aucune réclamation n'ait été déposée ou ne soit sur le point de l'être.",
      },
      {
        question: "Comment les réclamations sont-elles traitées ?",
        answer:
          "Chaque compagnie d'assurance dispose d'un service des réclamations ou d'une société tierce de gestion des réclamations pour traiter les réclamations. En cas d'urgence, vous devez appeler immédiatement la société d'assistance pour obtenir la meilleure aide disponible gratuitement.",
      },
      {
        question: "Combien de temps faut-il pour obtenir le remboursement ?",
        answer:
          "Généralement, il faut de 3 à 10 jours ouvrables pour que le remboursement soit traité.",
      },
      {
        question: "La police d'assurance Super Visa peut-elle être renouvelée ?",
        answer:
          "Oui, l'assurance peut être renouvelée pour une autre année. Si des réclamations ont été déposées, ces conditions seront qualifiées de conditions préexistantes.",
      },
      {
        question: "Qu'est-ce qui distingue notre plan d'assurance Super Visa ?",
        answer:
          "Les plans peuvent différer par le prix, le montant de couverture, les règles sur les conditions préexistantes, la couverture des voyages secondaires et la flexibilité de remboursement. Comparer ces caractéristiques vous aide à choisir le plan qui convient le mieux à votre famille.",
      },
      {
        question: "Comment puis-je obtenir un remboursement complet ou partiel ?",
        answer:
          "Il n'y aura pas de remboursement de prime si une réclamation a été déposée. Les remboursements pour annulations partielles seront calculés en multipliant la prime quotidienne par le nombre réel de jours pendant lesquels la police était en vigueur ; si ce montant est inférieur à la prime minimale requise, la prime minimale sera utilisée. Ce montant est ensuite soustrait de la prime totale payée moins tous les frais d'administration et versé au mode de paiement original, c.-à-d. prime totale payée 3 650 $ pour 365 jours. Si vous avez séjourné 200 jours, le reste des 165 jours de prime équivalant à 1 650 $ moins tous les frais d'administration conformément au libellé de votre police.",
      },
      {
        question: "Qu'est-ce qu'un montant de franchise ?",
        answer:
          "Une franchise désigne le montant que l'assuré doit payer avant d'être remboursé pour les frais médicaux admissibles. Généralement, une franchise offre des économies de prime allant de 10 % à 45 %.",
      },
      {
        question: "Aurai-je un remboursement complet si mon visa est refusé ?",
        answer:
          "Oui, un remboursement complet est disponible en cas de refus de visa, après présentation d'une preuve de la lettre de refus. Dans certains cas, des frais peuvent être appliqués - veuillez vous référer au libellé de votre police.",
      },
      {
        question:
          "Une police d'assurance Super Visa peut-elle être prolongée, si le souscripteur ne souhaite pas renouveler ?",
        answer:
          "Oui, elle peut être prolongée pour les jours requis, jusqu'à 558 jours selon l'un de nos produits.",
      },
      {
        question:
          "Un voyage secondaire vers une autre destination, autre que le Canada, est-il couvert par l'assurance Super Visa ?",
        answer:
          "Oui, tous les voyages secondaires autres que le pays d'origine sont couverts jusqu'à une période maximale conformément au libellé de la police.",
      },
      {
        question: "Qu'est-ce qu'une période d'attente dans une police ?",
        answer:
          "C'est le délai pendant lequel un assuré doit attendre après une blessure ou une maladie pour qu'un traitement puisse faire l'objet d'une réclamation.",
      },
      {
        question: "La période d'attente s'applique-t-elle à toutes les polices ?",
        answer:
          "Non, cela dépend du fait que la police est déjà en continuation ou non, et si elle provient de la même compagnie ou d'une organisation différente.",
      },
    ],
  },

  disability: {
    heading: null,
    faqs: [
      {
        question: "Qu'est-ce que l'assurance invalidité ?",
        answer:
          "L'assurance invalidité fournit un remplacement mensuel de revenu si vous ne pouvez pas travailler en raison d'une maladie ou d'une blessure.",
      },
      {
        question: "Qui a besoin d'une assurance invalidité ?",
        answer:
          "Toute personne qui dépend de son chèque de paie, en particulier les travailleurs autonomes, les seuls soutiens de famille et les travailleurs à haut risque.",
      },
      {
        question: "Comment fonctionne l'assurance invalidité ?",
        answer:
          "Si vous devenez invalide et ne pouvez pas travailler, la police verse des prestations mensuelles pour couvrir le revenu perdu.",
      },
      {
        question: "Quels types d'invalidités sont couverts ?",
        answer:
          "Elle couvre les blessures physiques, les maladies chroniques et les troubles de santé mentale qui vous empêchent de travailler.",
      },
      {
        question: "Quelle couverture puis-je obtenir ?",
        answer:
          "La couverture varie, mais einsured.ca offre jusqu'à 3 500 $/mois ou 5 000 $/mois combinée avec la protection de prêt.",
      },
      {
        question: "L'assurance invalidité est-elle imposable ?",
        answer:
          "Si vous payez la police vous-même, les prestations sont exemptes d'impôt. Si votre employeur paie, les prestations peuvent être imposées.",
      },
      {
        question: "Combien de temps durent les prestations ?",
        answer:
          "Les périodes de prestations vont de 2 ans jusqu'à l'âge de 65 ans, selon votre police.",
      },
      {
        question:
          "Quelle est la différence entre l'assurance invalidité à court terme et à long terme ?",
        answer:
          "L'assurance invalidité à court terme couvre les invalidités temporaires pour des semaines ou des mois, tandis que l'assurance invalidité à long terme est conçue pour les conditions graves et peut verser des prestations pendant de nombreuses années ou jusqu'à l'âge de la retraite.",
      },
      {
        question: "Quel est le délai d'attente avant que les prestations commencent ?",
        answer:
          "Cela varie mais va généralement de 30 à 90 jours après la survenance de l'invalidité.",
      },
      {
        question: "Couvre-t-elle les accidents du travail ?",
        answer:
          "Si vous êtes travailleur autonome ou n'êtes pas admissible à l'indemnisation des travailleurs, l'assurance invalidité garantit votre protection.",
      },
      {
        question:
          "Puis-je obtenir une assurance invalidité si j'ai des conditions préexistantes ?",
        answer:
          "Oui, mais les conditions préexistantes peuvent avoir des périodes d'attente ou une couverture limitée.",
      },
      {
        question: "Puis-je obtenir une assurance invalidité si je suis travailleur autonome ?",
        answer:
          "Absolument ! C'est particulièrement important pour les travailleurs autonomes qui n'ont pas d'avantages sociaux offerts par leur employeur.",
      },
      {
        question: "L'assurance invalidité couvre-t-elle les troubles de santé mentale ?",
        answer:
          "Oui ! De nombreuses polices couvrent l'anxiété, la dépression et d'autres invalidités liées à la santé mentale.",
      },
      {
        question: "Combien coûte l'assurance invalidité ?",
        answer:
          "Cela dépend de l'âge, du type d'emploi, du montant de couverture et de l'état de santé, mais les plans peuvent être personnalisés pour s'adapter à votre budget.",
      },
      {
        question: "Puis-je personnaliser ma police avec des avenants ?",
        answer:
          "Oui ! Les options comprennent les remboursements de primes, la couverture étendue et les prestations améliorées pour les blessures liées à des accidents.",
      },
      {
        question: "Que se passe-t-il si je ne dépose jamais de réclamation ?",
        answer:
          "Avec einsured.ca, vous pouvez récupérer 50 % de vos primes après 10 ans si les réclamations représentent moins de 20 % des primes payées.",
      },
      {
        question:
          "Puis-je demander une assurance invalidité si j'ai déjà une police par le biais de mon employeur ?",
        answer:
          "Oui ! Les plans d'invalidité des employeurs sont souvent limités, donc une couverture personnelle assure une meilleure sécurité financière.",
      },
      {
        question: "Comment puis-je déposer une réclamation d'assurance invalidité ?",
        answer:
          "Il suffit de soumettre une preuve médicale d'invalidité et de compléter le processus de réclamation de l'assureur. einsured.ca vous guide tout au long du processus.",
      },
      {
        question: "Puis-je augmenter ma couverture ultérieurement ?",
        answer:
          "Oui, de nombreuses polices vous permettent d'ajuster la couverture à mesure que votre revenu augmente.",
      },
      {
        question: "Comment puis-je commencer ?",
        answer:
          "Obtenez un devis GRATUIT aujourd'hui sur einsured.ca ou prenez un rendez-vous rapide pour trouver le meilleur plan pour vous !",
      },
    ],
  },

  critical: {
    heading: null,
    faqs: [
      {
        question: "Qu'est-ce que l'assurance maladies graves ?",
        answer:
          "L'assurance maladies graves fournit un versement forfaitaire si vous êtes diagnostiqué avec une maladie grave comme le cancer, une crise cardiaque ou un AVC.",
      },
      {
        question: "En quoi est-elle différente de l'assurance invalidité ?",
        answer:
          "L'assurance invalidité remplace le revenu perdu mensuellement, tandis que l'assurance maladies graves vous donne un versement unique pour couvrir les dépenses médicales et personnelles.",
      },
      {
        question: "Qui devrait souscrire une assurance maladies graves ?",
        answer:
          "Toute personne souhaitant une protection financière contre les coûts élevés du traitement des maladies graves, en particulier les travailleurs autonomes et les seuls soutiens de famille.",
      },
      {
        question: "Quelles maladies sont couvertes ?",
        answer:
          "La couverture varie, mais la plupart des polices couvrent le cancer, les crises cardiaques, les AVC, les insuffisances organiques et les chirurgies majeures. Certaines couvrent plus de 25 conditions.",
      },
      {
        question: "Combien d'argent vais-je recevoir si je suis diagnostiqué ?",
        answer:
          "Vous recevez une somme forfaitaire libre d'impôt, allant généralement de 25 000 $ à 500 000 $, selon votre police.",
      },
      {
        question: "Puis-je utiliser le versement pour n'importe quoi ?",
        answer:
          "Oui ! Utilisez-le pour les traitements médicaux, le revenu perdu, les paiements hypothécaires, les voyages pour les soins ou toute dépense de votre choix.",
      },
      {
        question: "Que se passe-t-il si je ne tombe jamais malade ?",
        answer:
          "Certaines polices offrent un remboursement de prime si vous restez en bonne santé pendant une période déterminée (par exemple, 10 ans ou plus).",
      },
      {
        question: "Couvre-t-elle les conditions préexistantes ?",
        answer:
          "Les conditions préexistantes peuvent être exclues ou avoir une période d'attente, selon l'assureur.",
      },
      {
        question: "Couvre-t-elle tous les types de cancer ?",
        answer:
          "La plupart des polices couvrent les cancers mettant la vie en danger, mais les cancers à un stade précoce peuvent avoir des prestations limitées.",
      },
      {
        question:
          "Puis-je obtenir une couverture si j'ai des antécédents familiaux de maladies graves ?",
        answer:
          "Oui ! Des antécédents familiaux peuvent avoir un impact sur les primes, mais vous pouvez toujours être admissible à une couverture.",
      },
      {
        question: "Le versement est-il imposable ?",
        answer: "Non, votre prestation forfaitaire est libre d'impôt à 100 %.",
      },
      {
        question:
          "Ai-je besoin d'une assurance maladies graves si j'ai une assurance santé ?",
        answer:
          "Oui, car l'assurance santé ne couvre que les factures médicales, tandis que l'assurance maladies graves fournit des liquidités pour toutes les dépenses.",
      },
      {
        question: "Puis-je obtenir une couverture si je suis travailleur autonome ?",
        answer:
          "Absolument ! Elle est fortement recommandée pour les travailleurs autonomes qui n'ont pas d'avantages sociaux offerts par un employeur.",
      },
      {
        question:
          "Quelle est la différence entre l'assurance maladies graves à terme et permanente ?",
        answer:
          "L'assurance maladies graves à terme vous couvre pour une période déterminée, par exemple 10 ou 20 ans, généralement à un coût initial plus bas. La couverture permanente des maladies graves peut durer jusqu'à un âge avancé et peut offrir une protection à long terme plus stable, mais les primes sont généralement plus élevées.",
      },
      {
        question: "Combien cela coûte-t-il ?",
        answer:
          "Les primes dépendent de l'âge, de la santé, du montant de couverture et du type de police, mais les plans peuvent être personnalisés pour s'adapter à votre budget.",
      },
      {
        question: "Puis-je combiner l'assurance maladies graves et l'assurance invalidité ?",
        answer:
          "Oui ! De nombreuses personnes combinent les deux pour assurer une protection financière complète en cas de maladie ou de blessure.",
      },
      {
        question: "Comment puis-je déposer une réclamation ?",
        answer:
          "Il suffit de fournir une preuve médicale du diagnostic, et l'assureur traitera votre réclamation. einsured.ca vous guide tout au long du processus !",
      },
      {
        question: "Puis-je augmenter ma couverture ultérieurement ?",
        answer:
          "Certaines polices vous permettent d'améliorer la couverture à mesure que vos besoins changent.",
      },
      {
        question: "Y a-t-il une période d'attente avant de pouvoir déposer une réclamation ?",
        answer:
          "Oui, la plupart des polices ont une période d'attente de 30 à 90 jours après le diagnostic avant de pouvoir recevoir un versement.",
      },
      {
        question: "Comment puis-je commencer ?",
        answer:
          "Obtenez un devis GRATUIT sur einsured.ca ou prenez un rendez-vous rapide pour trouver le meilleur plan pour vous !",
      },
    ],
  },

  investments: {
    sections: [
      {
        heading: "Compte d'épargne libre d'impôt (CELI)",
        faqs: [
          {
            question: "Qu'est-ce qu'un CELI ?",
            answer:
              "Un Compte d'épargne libre d'impôt (CELI) est un compte enregistré où vos économies et investissements croissent à l'abri de l'impôt, et les retraits sont également libres d'impôt.",
          },
          {
            question: "Combien puis-je cotiser à un CELI ?",
            answer:
              "Pour 2024, la limite de cotisation est de 7 000 $. Si vous n'avez jamais cotisé, votre limite totale pourrait être plus élevée en raison des droits inutilisés.",
          },
          {
            question: "Que se passe-t-il si je verse trop de cotisations dans mon CELI ?",
            answer:
              "Une pénalité mensuelle de 1 % sera prélevée sur l'excédent jusqu'à ce qu'il soit retiré.",
          },
          {
            question: "Puis-je retirer de mon CELI à tout moment ?",
            answer:
              "Oui ! Vous pouvez retirer de l'argent libre d'impôt à tout moment, et le montant retiré est ajouté à vos droits de cotisation l'année suivante.",
          },
          {
            question: "Qu'est-ce que je peux détenir dans un CELI ?",
            answer:
              "Vous pouvez investir dans des actions, des obligations, des fonds communs de placement, des FNB, des CPG et des économies en espèces dans un CELI.",
          },
        ],
      },

      {
        heading: "Régime d'accession à la propriété (RAP)",
        faqs: [
          {
            question: "Qu'est-ce que le Régime d'accession à la propriété (RAP) ?",
            answer:
              "Le RAP permet aux acheteurs d'une première maison de retirer jusqu'à 35 000 $ de leurs REER libres d'impôt pour acheter une maison.",
          },
          {
            question:
              "Dois-je rembourser l'argent que je retire dans le cadre du RAP ?",
            answer:
              "Oui, vous devez rembourser le montant total dans les 15 ans, à partir de la deuxième année après le retrait.",
          },
          {
            question: "Puis-je utiliser le RAP si j'ai déjà possédé une maison ?",
            answer:
              "Vous pouvez être à nouveau admissible si vous n'avez pas possédé de maison au cours des 4 dernières années avant le retrait.",
          },
          {
            question: "Que se passe-t-il si je ne rembourse pas mon retrait RAP ?",
            answer:
              "Tout montant impayé pour l'année est ajouté à votre revenu imposable et vous paierez de l'impôt dessus.",
          },
          {
            question: "Mon conjoint et moi pouvons-nous tous les deux utiliser le RAP ?",
            answer:
              "Oui ! Chaque personne peut retirer 35 000 $ de son REER, pour un total combiné de 70 000 $ pour l'achat d'une maison.",
          },
        ],
      },

      {
        heading: "Régime enregistré d'épargne-études (REEE)",
        faqs: [
          {
            question: "Qu'est-ce qu'un REEE ?",
            answer:
              "Un Régime enregistré d'épargne-études (REEE) aide les parents à épargner pour les études postsecondaires de leur enfant grâce à des subventions gouvernementales et à une croissance à imposition différée.",
          },
          {
            question: "Combien puis-je cotiser à un REEE ?",
            answer:
              "Il y a une limite à vie de 50 000 $ par enfant, mais pas de limite de cotisation annuelle.",
          },
          {
            question: "Qu'est-ce que la Subvention canadienne pour l'épargne-études (SCEE) ?",
            answer:
              "La SCEE correspond à 20 % de vos cotisations REEE, jusqu'à 500 $ par année par enfant (maximum 7 200 $ à vie).",
          },
          {
            question: "Que se passe-t-il si mon enfant ne va pas à l'école ?",
            answer:
              "Vous pouvez transférer le REEE à un autre enfant, retirer l'argent (avec des pénalités sur les subventions) ou transférer jusqu'à 50 000 $ à votre REER si vous avez des droits.",
          },
          {
            question: "Les retraits REEE sont-ils imposables ?",
            answer:
              "Seule la croissance des investissements et les subventions gouvernementales sont imposées lors du retrait. Vos cotisations originales sont libres d'impôt.",
          },
        ],
      },

      {
        heading: "Régime enregistré d'épargne-retraite (REER)",
        faqs: [
          {
            question: "Qu'est-ce qu'un REER ?",
            answer:
              "Un Régime enregistré d'épargne-retraite (REER) est un compte à imposition différée qui aide les Canadiens à épargner pour la retraite tout en réduisant leur revenu imposable.",
          },
          {
            question: "Combien puis-je cotiser à mon REER ?",
            answer:
              "Pour 2024, la limite de cotisation est de 18 % de votre revenu de l'année précédente, jusqu'à un maximum de 31 560 $, plus tout droit de cotisation inutilisé.",
          },
          {
            question: "Quand devrais-je retirer de mon REER ?",
            answer:
              "Il est préférable de retirer à la retraite lorsque votre revenu est plus faible, car les retraits sont imposés comme un revenu.",
          },
          {
            question: "Que se passe-t-il avec mon REER à l'âge de 71 ans ?",
            answer:
              "Vous devez le convertir en FERR (Fonds enregistré de revenu de retraite) ou acheter une rente avant le 31 décembre de l'année où vous atteignez 71 ans.",
          },
          {
            question: "Qu'est-ce que le Compte d'épargne libre d'impôt pour l'achat d'une première propriété (CELIAPP) ?",
            answer:
              "Le CELIAPP est un compte libre d'impôt conçu pour aider les acheteurs d'une première maison à épargner jusqu'à 40 000 $ pour leur première maison, avec des déductions fiscales sur les cotisations et des retraits libres d'impôt pour l'achat d'une maison.",
          },
        ],
      },

      {
        heading: "Compte d'épargne libre d'impôt pour l'achat d'une première propriété (CELIAPP)",
        faqs: [
          {
            question: "Qu'est-ce que le Compte d'épargne libre d'impôt pour l'achat d'une première propriété (CELIAPP) ?",
            answer:
              "Le CELIAPP est un compte d'épargne à avantages fiscaux conçu pour aider les acheteurs d'une première maison à épargner jusqu'à 40 000 $ pour une maison, avec des cotisations déductibles d'impôt et des retraits libres d'impôt pour un achat de maison admissible.",
          },
          {
            question: "Combien puis-je cotiser à un CELIAPP annuellement ?",
            answer:
              "Vous pouvez cotiser jusqu'à 8 000 $ par année, avec une limite de cotisation à vie de 40 000 $. Tout droit de cotisation inutilisé est reporté.",
          },
          {
            question: "Quels sont les avantages fiscaux d'un CELIAPP ?",
            answer:
              "Les cotisations au CELIAPP sont déductibles d'impôt (comme un REER), et les retraits pour l'achat d'une maison sont libres d'impôt (comme un CELI).",
          },
          {
            question: "Qui est admissible à un CELIAPP ?",
            answer:
              "Vous devez être un résident canadien, avoir au moins 18 ans et être un acheteur d'une première maison (ce qui signifie que vous n'avez pas possédé de maison au cours des 4 dernières années).",
          },
          {
            question: "Dans quoi puis-je investir dans mon CELIAPP ?",
            answer:
              "Vous pouvez investir dans des actions, des obligations, des FNB, des fonds communs de placement, des CPG et des économies en espèces dans un CELIAPP.",
          },
          {
            question:
              "Puis-je utiliser à la fois le CELIAPP et le Régime d'accession à la propriété (RAP) ?",
            answer:
              "Oui ! Vous pouvez combiner les deux programmes, vous permettant de retirer jusqu'à 40 000 $ d'un CELIAPP et 35 000 $ d'un REER libres d'impôt pour votre première maison.",
          },
          {
            question: "Que se passe-t-il si je n'achète pas de maison ?",
            answer:
              "Vous pouvez transférer vos économies CELIAPP libres d'impôt dans un REER ou un FERR sans affecter vos droits de cotisation au REER.",
          },
          {
            question: "Combien de temps puis-je garder mon CELIAPP ouvert ?",
            answer:
              "Vous devez utiliser les fonds du CELIAPP dans les 15 ans suivant l'ouverture du compte ou avant vos 71 ans, selon la première éventualité.",
          },
          {
            question:
              "Puis-je retirer des fonds CELIAPP pour autre chose qu'une maison ?",
            answer:
              "Oui, mais les retraits non admissibles sont imposables, tout comme les retraits d'un REER.",
          },
          {
            question: "Comment puis-je commencer avec un CELIAPP ?",
            answer:
              "Ouvrez un CELIAPP auprès d'une institution financière et commencez à cotiser. Obtenez une consultation GRATUITE sur einsured.ca pour trouver le meilleur plan pour vous !",
          },
        ],
      },
    ],
  },
};

const Faqs = () => {
  const [activeCategory, setActiveCategory] = useState("life");
  const [openIndex, setOpenIndex] = useState(null);

  const siteContainer = "mx-auto w-full max-w-[1380px] px-4 sm:px-6 lg:px-10";

  const handleCategoryClick = (id) => {
    setActiveCategory(id);
    setOpenIndex(null);
  };

  const currentCategory = FAQ_DATA[activeCategory];

  const sections = currentCategory.sections || [
    {
      heading: currentCategory.heading,
      faqs: currentCategory.faqs,
    },
  ];

  const toggleFaq = (key) => {
    setOpenIndex(openIndex === key ? null : key);
  };

  return (
    <>
      <SEO
        title="FAQ assurance | Questions fréquentes – einsured.ca"
        description="Trouvez des réponses sur la couverture, les réclamations et les coûts d’assurance avec einsured.ca pour faire des choix éclairés au Canada."
        keywords="FAQ assurance, questions assurance Super Visa, réclamations assurance-vie Canada, aide CELI REEE REER"
      />
      {/* HERO SECTION */}
      <section
        className="relative min-h-[60vh] sm:min-h-[70vh] md:min-h-[80vh] flex items-center justify-center md:justify-start bg-cover bg-top"
        style={{
          backgroundImage: `url(${img46})`,
          backgroundPosition: "center top",
        }}
      >
        <div className="absolute inset-0 bg-black/40" />

        <div className={`relative z-10 ${siteContainer}`}>
          <div className="max-w-4xl text-white text-center md:text-left">
            <h1 className="text-4xl sm:text-5xl md:text-7xl font-bold mb-3 sm:mb-4 md:mb-6 md:whitespace-nowrap leading-tight">
              Questions fréquemment posées
            </h1>

            <p className="text-base sm:text-xl font-medium mt-0 mb-6">
              Des réponses claires et concises pour fournir des informations
              directes sur l'assurance, les investissements et vos questions les
              plus courantes
            </p>
          </div>
        </div>
      </section>

      {/* TABS + FAQ  */}
      <section className="py-16 sm:py-20 bg-[#f7f9fc] text-gray-900">
        <div className={siteContainer}>
          <div className="max-w-5xl mx-auto">
            <div className="max-w-5xl mx-auto mb-8 sm:mb-10">
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5">
                {FAQ_CATEGORIES.map((cat, index) => {
                  const isActive = activeCategory === cat.id;
                  return (
                    <button
                      key={cat.id}
                      type="button"
                      onClick={() => handleCategoryClick(cat.id)}
                      className={`relative w-full px-3 sm:px-4 lg:px-6 py-2.5 sm:py-3 lg:py-4
                      text-xs sm:text-sm lg:text-base font-semibold text-center border border-sky-300 transition-all
                      ${
                        isActive
                          ? "bg-sky-400 text-white shadow-md"
                          : "bg-sky-50 text-gray-900 hover:bg-sky-100"
                      }
                      ${index === 0 ? "rounded-l-md" : ""}
                      ${
                        index === FAQ_CATEGORIES.length - 1
                          ? "rounded-r-md"
                          : ""
                      }`}
                    >
                      <span className="block leading-snug">{cat.label}</span>
                      {isActive && (
                        <span className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-3 h-3 bg-sky-400 rotate-45" />
                      )}
                    </button>
                  );
                })}
              </div>
            </div>

            {/* SECTIONS */}
            {sections.map((section, sectionIndex) => (
              <div key={sectionIndex} className="mb-10 sm:mb-12">
                {section.heading && (
                  <h2 className="text-2xl sm:text-3xl font-bold text-[#415a9c] text-center mb-6 sm:mb-8">
                    {section.heading}
                  </h2>
                )}

                <div className="space-y-4">
                  {section.faqs.map((item, index) => {
                    const key = `${sectionIndex}-${index}`;
                    const isOpen = openIndex === key;
                    const panelId = `faq-panel-${activeCategory}-${key}`;
                    const btnId = `faq-btn-${activeCategory}-${key}`;

                    return (
                      <div
                        key={key}
                        className="bg-white rounded-xl shadow-sm border border-gray-200"
                      >
                        <button
                          id={btnId}
                          type="button"
                          onClick={() => toggleFaq(key)}
                          aria-expanded={isOpen}
                          aria-controls={panelId}
                          className="w-full flex items-center justify-between px-5 sm:px-7 py-4 sm:py-5 text-left"
                        >
                          <span className="text-base sm:text-lg md:text-xl font-semibold">
                            {item.question}
                          </span>
                          {isOpen ? (
                            <Minus className="w-5 h-5 sm:w-6 sm:h-6" />
                          ) : (
                            <Plus className="w-5 h-5 sm:w-6 sm:h-6" />
                          )}
                        </button>

                        {isOpen && (
                          <div
                            id={panelId}
                            role="region"
                            aria-labelledby={btnId}
                            className="px-5 sm:px-7 pb-5 text-sm sm:text-base text-gray-700"
                          >
                            {item.answer}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Faqs;
